const dynamicDiscounting = 'dynamic-discounting'
const confirming = 'confirming'
const reverseFactoring = 'reverse-factoring'
const creditCard = 'credit-card'
const evolvedPayByLink = 'evolved-pay-by-link'
const creditCardOrderToCash = 'order-to-cash-credit-card'
const crossBorder = 'cross-border-payments'
const cooperativeProgram = 'cooperative-program'
const manualInputOutput = 'manual-input-output'
module.exports = {
  cooperativeProgram,
  reverseFactoring,
  crossBorder,
  dynamicDiscounting,
  confirming,
  creditCard,
  evolvedPayByLink,
  creditCardOrderToCash,
  manualInputOutput,
  passivePrograms: [manualInputOutput, reverseFactoring, dynamicDiscounting, confirming, creditCard, crossBorder, cooperativeProgram],
  activePrograms: [creditCardOrderToCash, evolvedPayByLink]
}
